module.exports = __webpack_public_path__ + "static/media/Tower_Bronzechest_openingV2_compressed.3b678aaa.mp4";